import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notification } from 'antd';
import { AxiosError } from 'axios';

import api from '../../utils/api';

type VerifyDocumentResponse = Response & {
  data?: StudentDocument | null;
};

export const useVerifyDocumentMutation = (applicantId?: string | number) => {
  const queryClient = useQueryClient();

  const verifyDocument = async (payload: VerifyStudentDocumentPayload): Promise<VerifyDocumentResponse> => {
    return (await api.post('/AdmissionDocument/Admin/VerifyDocument', payload))?.data;
  };

  const mutation = useMutation<VerifyDocumentResponse, AxiosError<ApiErrorResponse>, VerifyStudentDocumentPayload>({
    mutationKey: ['verify-student-document'],
    mutationFn: verifyDocument,
  });

  const verifyDocumentHandler = async (payload: VerifyStudentDocumentPayload) => {
    try {
      await mutation.mutateAsync(payload, {
        onSuccess: (data) => {
          notification.success({
            message: data?.message || 'Document verification updated successfully',
          });

          queryClient.refetchQueries({
            queryKey: ['get-student-documents', applicantId],
          });
        },
      });

      return true;
    } catch (error: any) {
      notification.error({
        message: 'Error',
        description:
          error?.response?.data?.message ||
          error?.response?.data?.title ||
          'Failed to verify document',
      });

      return false;
    }
  };

  return {
    verifyDocumentHandler,
    isLoading: mutation.isPending,
  };
};
